import { useState } from "react";
import AdSense from "../AdSense/AdSense";
import { AD_SLOTS } from "../../config/adSlots";
import "./StickyAd.sass";

const STICKY_AD_CLOSED_UNTIL_KEY = "sticky_ad_closed_until";
const STICKY_AD_HIDE_DURATION_MS = 24 * 60 * 60 * 1000;

function isStickyAdDismissed() {
    try {
        const closedUntil = Number(localStorage.getItem(STICKY_AD_CLOSED_UNTIL_KEY));

        if (!closedUntil) return false;

        if (Date.now() < closedUntil) {
            return true;
        }

        localStorage.removeItem(STICKY_AD_CLOSED_UNTIL_KEY);
        return false;
    } catch {
        return false;
    }
}

function saveStickyAdDismissal() {
    try {
        localStorage.setItem(STICKY_AD_CLOSED_UNTIL_KEY, String(Date.now() + STICKY_AD_HIDE_DURATION_MS));
    } catch {
        // If storage is blocked, keep the ad closed for the current page session only.
    }
}

function StickyAd() {
    const [closed, setClosed] = useState(isStickyAdDismissed);

    const handleClose = () => {
        saveStickyAdDismissal();
        setClosed(true);
    };

    const handleClosePress = (event) => {
        event.preventDefault();
        event.stopPropagation();
        handleClose();
    };

    if (closed) return null;

    return (
        <div className="sticky-ad">
            <button
                className="sticky-ad__close"
                type="button"
                onPointerDown={handleClosePress}
                onClick={handleClosePress}
                aria-label="Închide reclama"
            >
                ✕
            </button>
            <div className="sticky-ad__content">
                <AdSense adSlot={AD_SLOTS.stickyBottom} adFormat="auto" fullWidthResponsive />
            </div>
        </div>
    );
}

export default StickyAd;
